function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: 128.41,
  x2: 161.2,
  y1: 611.02,
  y2: 611.02
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#bd4e00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#fffe5b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#ffd300"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#e18100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#ffd300"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#ffffed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#ffd300"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#bc4d00"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  gradientUnits: "userSpaceOnUse",
  x1: 7158.84,
  x2: 7191.63,
  y1: 7630.43,
  y2: 7630.43
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.15,
  stopColor: "#c4c4c4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#858585"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#1d1d1d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.52,
  stopColor: "#858585"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#e2e2e2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8,
  stopColor: "#858585"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
}));

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  gradientUnits: "userSpaceOnUse",
  x1: 7175.24,
  x2: 7175.24,
  y1: 6952.79,
  y2: 6913.68
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e3e3e3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#696969"
}));

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  gradientUnits: "userSpaceOnUse",
  x1: 7175.24,
  x2: 7175.24,
  y1: 6967.68,
  y2: 6691.71
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#a36700"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#bd7700"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#d6972b"
}));

var _ref6 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "e",
  cx: 7175.24,
  cy: 6829.7,
  gradientUnits: "userSpaceOnUse",
  r: 150.49
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fd5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#fc0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#b56d00"
}));

var _ref7 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  gradientUnits: "userSpaceOnUse",
  x1: 7193.42,
  x2: 7193.42,
  y1: 6822.67,
  y2: 6706.5
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#373737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f3f3f3"
}));

var _ref8 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: 7247.6,
  x2: 7247.6,
  xlinkHref: "#f",
  y1: 6862.51,
  y2: 6805.56
});

var _ref9 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: 7100.35,
  x2: 7100.35,
  xlinkHref: "#f",
  y1: 6860.15,
  y2: 6803
});

var _ref10 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: 7216.09,
  x2: 7216.09,
  xlinkHref: "#f",
  y1: 6955.53,
  y2: 6862.25
});

var _ref11 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: 7134.46,
  x2: 7134.46,
  xlinkHref: "#f",
  y1: 6955.53,
  y2: 6862.32
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m128.41 170.03h32.8v881.98h-32.8z",
  fill: "url(#a)"
});

var _ref13 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-7030.43 -6691.71)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7191.63 7743.72a69.9 69.9 0 0 1 -32.79 0v-228.54h32.79z",
  fill: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7191.63 6913.68h-32.79v39.11l11.18-6.47a11.84 11.84 0 0 1 10.43 0l11.18 6.47z",
  fill: "url(#c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7261.32 6967.68a9 9 0 0 1 -4.48-1.37l-76.39-44.23a11.93 11.93 0 0 0 -10.43 0l-76.39 44.23a9 9 0 0 1 -4.48 1.37 5.33 5.33 0 0 1 -4.24-2c-.89-1.1-1.79-3.12-1.06-6.53l18.45-86.32a11.85 11.85 0 0 0 -3.22-9.92l-65.67-59c-3.42-3.07-3.17-5.86-2.72-7.24s1.89-3.79 6.46-4.26l87.8-9.12a11.88 11.88 0 0 0 8.44-6.13l35.8-80.69c1.87-4.2 4.59-4.83 6.05-4.83s4.18.63 6 4.83l35.8 80.69a11.86 11.86 0 0 0 8.44 6.13l87.81 9.12c4.57.47 6 2.87 6.46 4.26s.69 4.17-2.73 7.24l-65.68 59a11.91 11.91 0 0 0 -3.22 9.92l18.46 86.33c.73 3.4-.17 5.42-1.06 6.52a5.32 5.32 0 0 1 -4.2 2z",
  fill: "url(#d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7178.45 6696.44 36.18 81.53a15.1 15.1 0 0 0 11.09 8.06l88.72 9.21c4.35.45 5.24 3.19 2 6.11l-66.37 59.65a15.07 15.07 0 0 0 -4.24 13l18.65 87.23c.92 4.28-1.41 6-5.19 3.78l-77.2-44.7a15.13 15.13 0 0 0 -13.71 0l-77.19 44.7c-3.79 2.19-6.12.5-5.2-3.78l18.65-87.23a15.1 15.1 0 0 0 -4.24-13l-66.35-59.6c-3.26-2.92-2.37-5.66 2-6.11l88.72-9.21a15.1 15.1 0 0 0 11.09-8.06l36.19-81.53c1.75-4.05 4.62-4.05 6.4-.05z",
  fill: "url(#e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7140.5 6779.53 31.6-71.22c1.15-2.58 2-2.38 1.92.44l-3.3 111.75c-.08 2.82-1.56 3.3-3.29 1.07l-25.87-33.33a9.39 9.39 0 0 1 -1.06-8.71z",
  fill: "#fff",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7178.37 6708.31 31.41 70.79a9.44 9.44 0 0 1 -1.05 8.72l-25.73 33.44c-1.72 2.23-3.18 1.76-3.27-1.06l-3.3-111.45c-.07-2.82.79-3.02 1.94-.44z",
  fill: "url(#f)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7050.77 6799 75.93-7.89a9.44 9.44 0 0 1 8 3.69l23.49 34.25c1.59 2.33.69 3.57-2 2.78l-105.55-30.87c-2.75-.82-2.64-1.7.13-1.96z",
  fill: "#d3d3d3",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7222 6792.3 76.41 7.94c2.81.29 2.88 1.17.18 2l-105.84 31c-2.71.79-3.62-.46-2-2.79l23.33-34.37a9.41 9.41 0 0 1 7.92-3.78z",
  fill: "#fff",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7194 6844.24 106.89-38.24c2.66-.95 3.11-.2 1 1.69l-58.71 52.74a9.41 9.41 0 0 1 -8.61 1.7l-40.6-14.43c-2.66-.98-2.66-2.51.03-3.46z",
  fill: "url(#g)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7117.06 6866.22 40.29-11.88c2.71-.8 3.61.45 2 2.78l-62.59 91.75c-1.59 2.33-2.4 2-1.81-.78l16.13-75.42a9.47 9.47 0 0 1 5.98-6.45z",
  fill: "#fff",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7193.08 6855.54 40.25 11.67a9.43 9.43 0 0 1 6 6.42l16.19 75.74c.59 2.75-.22 3.1-1.8.77l-62.64-91.81c-1.61-2.33-.71-3.58 2-2.79z",
  fill: "#d3d3d3",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7047 6803.41 107 38.3c2.66.95 2.66 2.5 0 3.45l-40.43 14.57a9.38 9.38 0 0 1 -8.61-1.68l-58.96-52.95c-2.08-1.88-1.63-2.64 1-1.69z",
  fill: "url(#h)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7178.74 6907.67 1.18-42.95c.07-2.82 1.53-3.29 3.26-1.06l69.27 89.63c1.73 2.24 1.15 2.91-1.3 1.49l-68.15-39.45a9.43 9.43 0 0 1 -4.26-7.66z",
  fill: "url(#i)",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  d: "m7170.53 6864.78 1.36 42.78a9.38 9.38 0 0 1 -4.26 7.67l-68.31 39.55c-2.44 1.42-3 .76-1.3-1.48l69.23-89.58c1.75-2.23 3.19-1.72 3.28 1.06z",
  fill: "url(#j)",
  opacity: 0.7
}));

function SvgEnchanted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 289.62 1053.96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnchanted);
export default __webpack_public_path__ + "static/media/enchanted.cdfc4504.svg";
export { ForwardRef as ReactComponent };